import { useSelector } from 'react-redux';
import TutoComponent from '../views/tuto';
import { CliniqueState, StepView } from '../type';
import NewCamera from './NewCamera';
import ShadematchAnalyse from './analyse';
import ShadematchPrivacyPolicy from './privacyPolicy';
import ShadematchResults from './results';
import WristCamera from './WristCamera';

const ShadematchViewDispatcher = () => {
	const stepView = useSelector((state: CliniqueState) => state.session.stepView);

	switch (stepView) {
		case StepView.tuto:
			return <TutoComponent />;
		case StepView.camera:
			return <NewCamera />;
		case StepView.shadematchWristCamera:
			return <WristCamera />;
		case StepView.shadematchPictureAnalyse:
			return <ShadematchAnalyse />;
		case StepView.shadematchResults:
			return <ShadematchResults />;
		case StepView.shadematchPrivacy:
		default:
			return <ShadematchPrivacyPolicy />;
	}
};

export default ShadematchViewDispatcher;
